export const fengTheme = {
    name: 'feng',
    properties: {
        '--background': '#F8F8F8',
        '--on-background': '#000000',
        '--primary': '#141414',
        '--on-primary': '#F8F8F8',
        '--secondary': '#F6A318',
        '--on-secondary': '#FFFFFF',
        '--surface': '#F8F8F8',
        '--on-surface': '#11224F',
        '--error': '#F25455',
        '--on-error': '#fff',
        '--warning': '#EFC845',
        '--on-warning': '#fff',
        '--success': '#C47E08',
        '--on-success': '#fff',
        '--info': '#D0D0D0',
        '--on-info': '#fff',
        '--primary-RGB': '65, 65, 65',
        '--primary-light': '#F8F8F8',
        '--primary-dark': '#0A0A0A',
        '--secondary-dark': '#C47E08',
        '--secondary-RGB': '246,163,24',
        '--surface-RGB': '0, 0, 0',
        '--error-RGB': '255, 255, 255',
        '--warning-RGB': '255, 255, 255',
        '--success-RGB': '104,219,108',
        '--info-RGB': '255, 255, 255',
        '--on-background-RGB': '0,0,0',
        
        '--max-width': '1200px',

        // Add external fonts @font-face to styles.scss
        '--font-primary': 'Titillium Web',
        '--font-title': 'Titillium Web',
        '--font-button': 'Titillium Web',

        // Menu
        '--menu-itens-color': '--primary-light',
        '--menu-itens-background': 'transparent',
        '--menu-active-color': 'var(--primary)',
        '--menu-active-background': 'var(--secondary)',
        '--menu-active-underline': '0',

        '--menu-mobile-background': '#fff',
        '--menu-mobile-user-detail-color': '#404040',
        '--menu-mobile-user-detail-background': '#fff',
        '--menu-mobile-itens-color': '#404040',
        '--menu-mobile-itens-background': '#fff',

        // Header
        '--header-margin': '',
        // '--header-bg': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/cruz-malta-transp.png) no-repeat top center / auto, url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/header-det1.png) no-repeat top left / auto, url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/header-det2.png) no-repeat top right / auto',
        '--header-bg-color': 'url(https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/website/Banner-Desktop-Deslogada-header-only.png)',
        '--header-border-color': '#FFF',
        '--header-font-color': '#FFF',
        // '--header-mobile-bg': 'black url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/header-nova-ajustada.png) no-repeat top left 42% / cover',
        '--header-mobile-logo-width': '145px',
        '--header-desktop-logo-width': '240px',
        '--header-mobile-height': '100px',
        '--header-desktop-height': '180px',
        '--header-desktop-content-padding': '0',
        '--header-mobile-content-padding': '0',
        '--header-mobile-font-size': '14px',
        '--header-desktop-font-size': '18px',
        '--header-mobile-margin-top': '0',
        '--header-desktop-margin-top': '0',
        '--header-mobile-logo-top': '-20px',
        '--header-desktop-logo-top': '-20px',
        '--public-header-security-top-padding': '0',
        '--private-header-security-top-padding': '0',
        // '--header-logged-bg': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/cruz-malta-transp.png) my-profile-name-color, url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/header-det1.png) no-repeat top left / auto, url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/header-det2.png) no-repeat top right / auto',
        '--header-logged-mobile-logo-width': '150px',
        '--header-logged-desktop-logo-width': '260px',
        '--header-new-mobile-logo-width': '120px',
        '--header-new-desktop-logo-width': '160px',
        '--header-new-mobile-second-logo-width': '128.811px',
        
        '--header-counter-background': 'var(--primary)',
        '--header-counter-font-family': 'Heebo',
        '--header-counter-text-color': 'var(--secondary)',
        '--header-counter-color': 'var(--secondary)',
        '--header-counter-number-bg': 'var(--primary)',
        '--header-counter-number-border-color': 'var(--info)',
        '--header-counter-number-outline-color': 'var(--secondary-dark)',
        '--header-counter-number-font-family': 'ApexMk3',
        '--header-new-logo-justify-items': 'end',
        '--header-new-logo-justify-content':'end',
        '--header-new-logo-gap': '125px',

        //Hotsite
        '--hotsite-card-text-color': '#727272',

        // Home Public
        // Call to Action
        '--home-call-to-action-font-family': 'Titillium Web',
        '--home-call-to-action-background': 'linear-gradient(0deg, rgba(0, 0, 0, 0.33) 0%, rgba(0, 0, 0, 0.33) 100%)',
        '--home-call-to-action-background-img': 'linear-gradient(0deg, rgba(0,0,0,0.35) 100%, transparent), url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/cta-banner.png)',
        '--home-call-to-action-height': '800px',
        '--home-call-to-action-detail-color': 'var(--secondary)',
        //'--home-call-to-action-title-font-size': '72px',
        '--home-call-to-action-title-font-size': '66px',
        '--home-call-to-action-title-font-family': 'Titillium Web',
        '--home-call-to-action-title-font-weight': '900',
        '--home-call-to-action-title-margin': '0 0 24px 0',
        '--home-call-to-action-title-line-height': '130%',
        '--home-call-to-action-title-alternate-font-family': 'Roboto',
        '--home-call-to-action-title-alternate-font-size': '110px',
        '--home-call-to-action-subtitle-font-size': '20px',
        '--home-call-to-action-subtitle-width': '487px',
        '--home-call-to-action-subtitle-line-height': '130%',
        '--home-call-to-action-content-padding': '280px 20px 250px',
        '--home-call-to-action-content-align': 'left',
        '--home-call-to-action-button-margin': '0',
        '--home-call-to-action-button-background': 'var(--secondary)',
        '--home-call-to-action-button-padding': '8px 30px',
        '--home-call-to-action-button-font-size': '19px',
        '--home-call-to-action-button-style': 'normal',
        '--home-call-to-action-button-color': 'var(--primary)',
        '--home-call-to-action-hover-button-color': 'white',
        '--home-call-to-action-title-color': 'white',
        //'--home-call-to-action-title-desktop-max-width': '716px',
        '--home-call-to-action-title-desktop-max-width': '1228px',
        '--mobile-home-call-to-action-title-margin': '0 0 30px',
        '--mobile-home-call-to-action-content-padding': '80px 10% 50px',
        '--mobile-home-call-to-action-title-font-size': '40px',
        '--mobile-home-call-to-action-title-line-height': '120%',
        '--mobile-home-call-to-action-subtitle-font-size': '16px',
        '--mobile-home-call-to-action-subtitle-line-height': '150%',
        '--mobile-home-call-to-action-title-alternate-font-family': 'ApexMk3',
        '--mobile-home-call-to-action-title-alternate-font-size': '62px',
        '--call-to-action-margin-top': '0',
        '--call-to-action-padding-top': '30px',
        
        //Home tickets
        '--st-tickets-bg': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/partidas-bg.png) no-repeat center',
        '--st-tickets-desktop-padding': '32px 16px',
        '--st-tickets-mobile-padding': '16px',
        '--st-tickets-desktop-gap': '32px',
        '--st-tickets-mobile-gap': '24px',
        '--st-tickets-wrapper-bg': '#fff',
        '--st-tickets-desktop-wrapper-padding': '32px 40px',
        '--st-tickets-mobile-wrapper-padding': '24px',
        '--st-tickets-wrapper-text-color': '#393939',
        '--st-tickets-max-width': '1600px',
        '--st-tickets-action-max-width': '600px',
        '--st-tickets-action-desktop-gap': '16px',
        '--st-tickets-action-mobile-gap': '8px',
        '--st-tickets-box-shadow': '0 0 20px 5px rgba(0, 0, 0, 0.50)',
        '--st-tickets-outline-btn-color': '#333333',
        '--st-tickets-outline-btn-bg-color': '#fff',
        '--st-tickets-divider-color': '#333333',
        '--st-tickets-desktop-h2-font-size': '43px',
        '--st-tickets-desktop-h2-font-weight': '800',
        '--st-tickets-desktop-h2-line-height': '110%',
        '--st-tickets-mobile-h2-font-size': '28px',
        '--st-tickets-desktop-p-font-size': '32px',
        '--st-tickets-desktop-p-font-weight': '700',
        '--st-tickets-desktop-p-line-height': 'normal',
        '--st-tickets-mobile-p-font-size': '20px',
        '--st-tickets-shield-max-height': '98px',
        '--st-tickets-shield-img-width': '109px',
        '--st-tickets-shield-img-height': '109px',
        '--st-tickets-shield-img-width2': '95px',
        '--st-tickets-shield-img-height2': '95px',
        '--st-tickets-info-min-width': '245px',

        // Tabs
        '--home-desktop-tabs-1-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/img-conteudo1.png) no-repeat center',
        '--home-desktop-tabs-1-background-img': '#F8F8F8',
        '--home-desktop-tabs-2-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/img-conteudo2.png) no-repeat center',
        '--home-desktop-tabs-2-background-img': '#F8F8F8',
        '--home-desktop-tabs-3-background': 'no-repeat center center / cover',
        '--home-desktop-tabs-3-background-img': '#F8F8F8',
        '--home-view-tabs-wrapper-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/bg-scroll-conteudo.png)',
        '--home-view-tabs-content-color': '#333333',
        '--home-view-tabs-box-shadow': '0 0 24px 5px rgba(0, 0, 0, 0.16)',
        '--home-view-tabs-p-color': '#727272',
        '--home-view-tabs-wrapper-bg-color': '#fff',
        '--home-view-tabs-icon-color': '#C47E08',

        // First Access
        '--first-access-bg': '#000000',

        // Pending E-mail
        '--pending-mail-bg': 'white',
        '--pending-mail-color': 'black',
        '--pending-mail-logo-height': '100px',
        '--pending-mail-logo-bg': '#000',

        // Home Private
        '--home-private-padding-top': '0',

        // Plans
        '--plans-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/bg-planos.png) center no-repeat',
        '--plans-content-color': '#333333',
        '--plans-info-color': '#393939',
        '--plans-box-shadow': '-1.71058px 8px 16px 2px rgba(0, 0, 0, 0.24)',
        '--plans-border-color': '#C47E08',
        '--plans-reverse-order': 'true',


        // Event Info
        '--event-info-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/bg-scroll-conteudo3.png) left no-repeat',

        // Partner Scroll
        '--partners-img-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/bg-planos.png)',

        // My Profile
        '--my-profile-title-color': '#5B5B58',
        '--my-profile-name-color': '#5B5B58',

        // Proposts
        '--proposed-approve-button': 'var(--secondary)',
        '--proposed-approve-button-hover': '#99bd00',
        '--proposed-disapprove-button': 'var(--error)',
        '--proposed-disapprove-button-hover': '#cc4748',

        // Contact
        '--contact-background': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/flag-vasco1.png) no-repeat center center / cover',

        // Experiences
        '--experience-how-to-score-icon-filter': '',
        '--experience-points-table-background': '#ffffff',

        // Exclusive Content
        '--exclusive-content-text': 'var(--primary)',
        '--exclusive-content-background-RGB': '0,0,0',
        '--exclusive-content-background': 'white',

        // X-Ray 
        '--x-ray-text-color': '#232323',
        '--x-ray-call-to-action-background': '#000',
        '--x-ray-call-to-action-background-img': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/xray-featured-background.jpg)',
        '--x-ray-action-active-background-color': '#333333',
        '--x-ray-tabgroup-background': 'white',
        '--x-ray-action-not-active-background-color': '#D0D0D0',
        '--x-ray-tab-header-top-position': '50px',
        '--x-ray-tab-header-ink-bar-height': '0',
        '--x-ray-chart-colors': [
            'rgba(207, 255, 3)',
            'rgba(0, 0, 0)',
            'rgba(43, 45, 48)',
            'rgb(65,65,65)',
            'rgb(240, 241, 242)'
        ],
        '--x-ray-map-fill-color': '#000',
        '--x-ray-map-fill-hover-color': '#333333',
        '--x-ray-map-stroke-hover-color': '#F6A318',
        '--x-ray-map-tooltip-background': 'rgba(0, 0, 0, 1.0)',
        '--x-ray-map-tooltip-border': '2px solid rgba(0, 0, 0, 0.7)',
        '--x-ray-map-tooltip-color': '#fff',
        '--x-ray-transparency-background-color': 'rgba(0, 0, 0, 1.0)',
        '--x-ray-transparency-on-background-color': '#fff',

        // Events
        '--event-background-select': 'rgba(255, 255, 255, 0.5)',
        '--event-background-table': '#f8f8f8',
        '--event-color-button': '#F6A318',
        '--event-color-text-button': '#000000',
        '--event-color-text-default': '#f8f8f8',
        '--event-color-text-light': '#F6A318',
        '--event-color-text-dark': '#313131',
        '--event-color-text-primary': '#545452',
        '--event-color-text-secondary': '#F6A318',
        '--event-banner-text-primary': '#FFFFFF',
        '--event-banner-text-secondary': '#898989',

        // Biometry
        '--biometry-color-texts': '#393939',
        '--biometry-card-divider': '1px solid #E4E4E4',
        
        // Footer
        '--footer-item-margin': '25px auto',
        '--footer-color': 'white',
        '--footer-background': '#141414',
        '--footer-logo-width': '240px',
        '--footer-font-family': 'Barlow Semi Condensed',

        // Auth Modal
        '--auth-modal-stlogo-width': '180px',
        '--auth-modal-stlogo-bg': '#000000',
        '--auth-modal-closebtn-color': 'black',
        '--mobile-auth-modal-closebtn-color': 'white',
        '--mobile-auth-modal-stlogo-width': '100px',
        '--mobile-auth-modal-stlogo-margin': '10px 0',

        // Staging
        '--staging-logo-background-color': '#000000',

        // Gift Card
        '--gift-card-price-color': '#F6A318',
        '--giftcard-primary-color': '#F6A318',
    },
    images: {
        'stLogo': 'https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/website/logo-gigante-horizontal.svg',
        'stLogoMobile': 'https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/website/logo-gigante-horizontal.svg',
        'stLogoFooter': 'https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/website/logo-gigante-horizontal.svg',
        'loadingLogo': 'https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/website/logo-gigante-horizontal.svg',
        'stShield': 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/escudo-vasco.svg',
        '--homePlansBG': 'linear-gradient(180deg, #F8F8F8 0%, #000000 100%)',
        '--homeTicketsBG': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/bg-desktop.png)',
        '--homeExclusiveContentBG': 'url(https://vasco-gs.s3.amazonaws.com/prod/assets/images/bg-desktop.png)',
        'mailPendingLogo': 'https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/website/logo-gigante-horizontal.svg',
        header: {
            'stShieldHeader': 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/escudo-vasco.svg',
            // 'stSecondHeaderImg': 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/vasco-faixa.svg',
            'counterMobileBG': 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/bg-contador-mobile.png',
            'counterDesktopBG': 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/bg-contador-web.png',
        }
    },
    videos: {
        'bannerVideo': 'https://vasco-gs.s3.amazonaws.com/prod/assets/images/we/VAS_Video_Banner_1080p%20%281%29.mp4'
        //'https://vasco-gs.s3.amazonaws.com/prod/assets/images/website/2023/video-destaque-1scroll.mp4'
        // 'https://vasco-gs.s3.us-east-1.amazonaws.com/prod/assets/images/gigante_hero_video.mp4'
    },
    
    texts: {
        // Home
        // Call to Action
        //'callToActionFeatured': 'QUE HONRA<br> SER SÓCIO GIGANTE!',
        'callToActionFeatured':'A BARREIRA É PRA TODOS<br> E TODOS SOMOS GIGANTES!',
        'callToActionFeaturedImg': '',
        'callToActionDetail': 'Tenha prioridade e desconto na compra de ingressos, diversos benefícios e experiências exclusivas.',
        'callToActionButton': 'SEJA GIGANTE',
        //Home tickets
        'stTicketsTitle': 'Garanta já o seu ingresso!',
        'stTicketsButton': 'SEJA GIGANTE',
        'stTicketsBenefits': 'VER BENEFÍCIOS',
        // Auth
        // First Access
        'firstAccessText': 'Identificamos que este é o seu primeiro acesso ao nosso novo sistema. Para continuar, você deve ler e concordar com os termos de uso e com a política de privacidade!',
        // Recover Pass
        'recoverPassText': 'Preencha os campos abaixo para definir a sua nova senha.',
        //Rating
        'cardTitle': 'Entenda seu nível',
        'cardTitleContractTime': 'Longevidade do programa',
        'cardTitleCountGame': 'Frequência de jogos',
        'modalTitle': 'Saiba como funciona o Rating Gigante',
        'modalDescDefault': `
        <p>O <b>Rating Gigante</b> é o novo sistema que vai definir a prioridade dos sócios na compra de ingressos 
        e em outros benefícios do programa, quando aplicável e de acordo com as regras vigentes.</p>

        <p>A sua posição no Rating será formada pela soma do nível do seu plano (fixo) com os níveis 
        conquistados pelo seu engajamento como sócio.</p>

        <p>Esses níveis podem ser obtidos por meio da sua frequência aos jogos, do seu tempo ativo como 
        sócio ou pela combinação dos dois meios. Os níveis adicionais conquistados por engajamento são 
        sempre aplicados respeitando o nível máximo permitido para cada plano. Assim, mesmo que o 
        sócio atenda aos critérios para conquistar novos níveis, seu Rating não poderá ultrapassar o limite  
        previsto para o plano contratado.</p>

        <h3>Como ganhar níveis?</h3>

        <p>Você pode acumular níveis de duas formas:</p>

        <p><b>1 - Pelo seu plano</b></p>
        <p>Cada plano possui um nível inicial, mantido enquanto estiver ativo e regular como sócio torcedor 
        na base do Gigante, e um nível máximo que pode ser alcançado por meio do engajamento.</p>

        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>Dinamite Eterno</b> - Nível Inicial 6 - Nível Máximo 6</p>
        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>Gigante 5</b> - Nível Inicial 4 - Nível Máximo 6</p>
        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>Gigante 4</b> - Nível Inicial 3 - Nível Máximo 5</p>
        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>Gigante (3 e 2)</b> - Nível Inicial 2 - Nível Máximo 4</p>
        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>Norte a Sul</b> - Nível Inicial 2 - Nível Máximo 4</p>
        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>Camisas Negras</b> - Nível Inicial 1 - Nível Máximo 3</p>

        <p><b>Importante:</b> Os níveis conquistados por frequência e longevidade são somados ao nível inicial do 
        plano, respeitando sempre o nível máximo permitido para cada modalidade. Assim, mesmo que o 
        sócio cumpra todos os critérios de engajamento, seu Rating não poderá ultrapassar o limite 
        estabelecido para o plano contratado.  </p> 

        <p>Além do nível do plano, você pode conquistar níveis extras de acordo com o seu relacionamento com o Vasco.</p>

        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>1 nível por frequência</b>: Para quem registrar presença em no mínimo 10 nos últimos 12 meses corridos.</p>

        <p><i class="fengi-star-full" style="color: var(--secondary);"></i> <b>1 nível de longevidade a cada 2 anos consecutivos como sócio ativo</b>:</p>

        <p>Ao completar 2 anos consecutivos como sócio ativo, você ganha 1 nível adicional.</p>

        <p>Ao completar 4 anos consecutivos como sócio ativo, você ganha mais 1 nível adicional.</p>

        <h3>Como isso impacta a compra de ingressos?</h3>

        <p>Quanto maior o seu nível, mais cedo você poderá comprar ingressos.</p>

        <p>As vendas serão organizadas em ondas de prioridade:</p>

        <p><b>Onda 1</b> — Nível 6</p>
        <p><b>Onda 2</b> — Nível 5</p>
        <p><b>Onda 3</b> — Nível 4</p>
        <p><b>Onda 4</b> — Nível 3</p>
        <p><b>Onda 5</b> — Nível 2</p>
        <p><b>Onda 6</b> — Nível 1</p>
        <p><b>Onda 7</b> — Público Geral</p>

        <h3>Exemplo prático 01</h3>

        <p>Um novo sócio que adere o plano <b>Gigante 4</b>, começará seu Rating no Nível 3. Logo, terá prioridade de compra de ingresso na 4° onda.</p>

        <p>Se ele registrar presença em 10 jogos dentro dos primeiros 12 meses, por exemplo no mês 8 ele já 
        terá seu nível aumentado (por frequência), logo nos demais jogos deste ano poderá comprar seus 
        ingressos na 3° onda, passando para o Nível 4.</p>

        <h3>Exemplo prático 02</h3>

        <p>Um sócio que já está ativo há 4 anos no plano <b>Gigante 4</b>, começará seu Rating no Nível 5 (Máximo 
        do seu plano). Logo, já começará com a sua prioridade de compra de ingresso na 2° onda.</p>

        <p>Se ele registrar presença em 10 jogos dentro nos 12 meses corridos, não dará direito a mais um 
        nível pois já atingiu seu nível máximo do plano.</p>

        <h3>Avisos Importantes</h3>

        <p>Os níveis do plano são mantidos enquanto o sócio estiver na base do Gigante.</p>

        <p>A frequência aos jogos passa a ser considerada a partir da implementação do Rating 
        Gigante. O benefício de +1 nível será concedido aos sócios que registrarem presença em 
        pelo menos 10 jogos dentro dos últimos 12 meses, considerando apenas as presenças 
        elegíveis a partir da implementação do Rating.</p>

        <p>A longevidade será considerada de forma retroativa para os sócios ativos. Assim, o tempo 
        de permanência já acumulado no programa será considerado para a concessão dos níveis 
        de longevidade, respeitando as regras estabelecidas.</p>

        <p>O nível de frequência é recalculado continuamente com base nos últimos 12 meses e pode 
        ser perdido caso o requisito deixe de ser atendido.</p>

        <p>Os níveis de longevidade são mantidos enquanto o sócio permanecer na base do Gigante, 
        inclusive durante períodos de inatividade por inadimplência. Nesse período, o sócio não 
        poderá comprar ingressos nem usufruir dos benefícios do Rating, mas poderá regularizar 
        as parcelas em atraso sem perder seu histórico de longevidade.</p>

        <p>Os sócios Estatutários permanecem com prioridade máxima (na compra de ingressos) e 
        não participam da dinâmica de evolução do Rating Gigante.</p>

        <p>Em casos de cancelamento, finalização ou desligamento do programa, os níveis e 
        benefícios serão perdidos em sua totalidade.</p>
        
        <p>Novos benefícios poderão ser adicionados futuramente e serão divulgados pelos canais 
        oficiais do Clube de Regatas Vasco da Gama.</p>
        `,
    }
}